import axios from '../../axios/index.js'

export default {
    list() {
      return axios.get('get_categories')
    }
}
  